import React from 'react';
import { TERRAIN_TYPES } from '../../contexts/MapContext';

const WALL_IDS = ['wall', 'cave_rock', 'wood_wall', 'brick_wall', 'hedge', 'iron_bars'];

const TERRAIN    = TERRAIN_TYPES.filter((t) => !['empty', ...WALL_IDS].includes(t.id));
const WALLS      = TERRAIN_TYPES.filter((t) => WALL_IDS.includes(t.id));

function SwatchGrid({ tiles, selectedTerrain, onSelect }) {
  return (
    <div style={styles.grid}>
      {tiles.map((t) => (
        <button
          key={t.id}
          style={{
            ...styles.swatch,
            background: t.color,
            ...(selectedTerrain === t.id ? styles.selected : {}),
          }}
          onClick={() => onSelect(t.id)}
          title={t.difficult ? `${t.label} — difficult terrain (2× movement)` : t.label}
        >
          {t.difficult && <span style={styles.difficultBadge} title="Difficult terrain (2× movement)">2×</span>}
          <span style={styles.swatchLabel}>{t.label}</span>
        </button>
      ))}
    </div>
  );
}

export default function TerrainPalette({ selectedTerrain, onSelect }) {
  return (
    <div style={styles.panel}>
      <div style={styles.sectionHeader}>Terrain</div>
      <SwatchGrid tiles={TERRAIN} selectedTerrain={selectedTerrain} onSelect={onSelect} />

      <div style={{ ...styles.sectionHeader, marginTop: 12 }}>Walls</div>
      <SwatchGrid tiles={WALLS} selectedTerrain={selectedTerrain} onSelect={onSelect} />

      <p style={styles.hint}>Use the Door tools in the toolbar above to place doors.</p>
    </div>
  );
}

const styles = {
  panel:         { padding: '10px 14px', borderBottom: '1px solid #4a3d28' },
  sectionHeader: { fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: '#9a8b6e', marginBottom: 8 },
  grid:          { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 5 },
  swatch:        { height: 42, borderRadius: 6, border: '2px solid transparent', cursor: 'pointer', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', padding: '0 2px 3px', transition: 'border-color 0.12s, transform 0.1s', position: 'relative', overflow: 'hidden' },
  selected:      { borderColor: '#d4a847', transform: 'scale(1.05)', boxShadow: '0 0 10px rgba(192,132,252,0.5)' },
  swatchLabel:   { fontSize: 9, fontWeight: 700, color: '#fff', textShadow: '0 1px 3px #000, 0 0 6px #000', textTransform: 'uppercase', letterSpacing: '0.04em', pointerEvents: 'none' },
  difficultBadge: { position: 'absolute', top: 2, right: 2, fontSize: 9, fontWeight: 800, color: '#1a0e00', background: '#facc15', borderRadius: 3, padding: '0 4px', lineHeight: '14px', height: 14, textShadow: 'none', boxShadow: '0 1px 3px rgba(0,0,0,0.5)', pointerEvents: 'none' },
  hint:          { fontSize: 10, color: '#6a5d45', marginTop: 8, lineHeight: 1.4 },
};
